import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import { TextSemiBold } from 'UiKit/typography';
import { reportAttendanceTabText } from 'Const/report-attendance/text';
import { useReportAttendanceState } from 'View/report-attendance/state';

import styles from './styles.module.css';

const VALID_TABS = ['operator', 'host'];

const Tab = () => {
  const { selectedTab, updateState, resetFilterState } = useReportAttendanceState();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const tabParam = searchParams.get('tab');
    const tab = VALID_TABS.includes(tabParam) ? tabParam : 'operator';
    updateState({ selectedTab: tab });
    /* eslint-disable-next-line */
  }, []);

  const handleChangeTab = (tab) => {
    resetFilterState();
    updateState({ selectedTab: tab });
    setSearchParams((prev) => {
      prev.set('tab', tab);
      return prev;
    });
  };

  return (
    <Box className={styles['tab__container']}>
      <Box className={`${styles['tab__item']} ${selectedTab === 'operator' ? styles['tab__item--actived'] : ''}`} onClick={() => handleChangeTab('operator')}>
        <TextSemiBold className={styles['tab__text']}>{reportAttendanceTabText?.operatorTabText}</TextSemiBold>
      </Box>
      <Box className={`${styles['tab__item']} ${selectedTab === 'host' ? styles['tab__item--actived'] : ''}`} onClick={() => handleChangeTab('host')}>
        <TextSemiBold className={styles['tab__text']}>{reportAttendanceTabText?.hostTabText}</TextSemiBold>
      </Box>
    </Box>
  );
};

export default Tab;
